import { COLOR_BUTTON_SECONDARY, COLOR_TEXT_GRAY, COLOR_WH } from '../colors.constants';

export const colorsSlider = {
  colorSlider: COLOR_BUTTON_SECONDARY,
  colorSliderThumb: COLOR_TEXT_GRAY,
  colorSliderThumbMargin: COLOR_WH,
};
